export default "__VITE_ASSET__C6ZaGi6V__"